var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"contact"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Contact")]),_c('div',{staticClass:"contact-cards"},[_c('contact-form'),_c('email-social'),_c('blog-posts')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }